import { encumbranceOptions } from 'modules/_shared/components/Modals/UpdateShares/constants/encumbranceOptions';
import { Encumbrance } from 'types';

export const getEncumbranceLabel = (encumbrance: Encumbrance) => {
  const selectedEncumbrance = encumbranceOptions.find(
    (option) => option.value === encumbrance?.name
  );

  return selectedEncumbrance
    ? `ShareEncumbranceOption_${selectedEncumbrance.label}`
    : '';
};
